Ext.ns('mx.app.widget');

Ext.override(Ext.form.RadioGroup, {
    afterRender: function() {
        var group = this;
        this.items.each(function(field) {
            field.on('check', function(self, checked) {
                if (checked) {
                    group.fireEvent('change', group, self.getValue());
                }
            });
        });
        Ext.form.RadioGroup.superclass.afterRender.call(this);
    },
});

var ENABLE_RATE_DELIVERY = 'maxoptra.notification.enableRateDelivery';
var HIDE_RATE_DELIVERY = 'maxoptra.notification.hideRateDelivery';
var RATE_WIDGET_TEXT = 'maxoptra.notification.rateWidgetText';

mx.app.widget.PropertyForm = Ext.extend(mx.comp.FormPanel, {
    layout: 'auto',
    cls: 'property-edit-wrap',
    tabCLs: 'property-edit-tab',
    pageCLs: 'property-edit-page',
    tabAlign: 'vertical' /*** vertical | horizontal | none ***/,
    namespace: 'gt',
    tabNamespace: 'gt',
    autoHeight: true,
    autoWidth: true,
    autoScroll: false,
    readOnly: false,
    border: false,
    buttonAlign: 'right',
    minButtonWidth: '100%',
    metaData: null,
    newSchedulerOn: null,
    hideRateDelivery: null,

    showErrorMsg: function(message) {
        Ext.Msg.show({
            title: mx.translate('Error'),
            msg: message,
            icon: Ext.Msg.ERROR,
            buttons: Ext.Msg.OK,
        });
    },

    showInfoMsg: function(message) {
        Ext.Msg.show({
            title: mx.translate('Information'),
            msg: message,
            icon: Ext.Msg.INFO,
            buttons: Ext.Msg.OK,
        });
    },

    isNeedUpdate: function() {
        var isNeedUpdate = false;
        for (var i = 0; i < this.form.items.items.length; i++) {
            var el = this.form.items.items[i];
            for (var j = 0; j < this.metaData.length; j++) {
                meta = this.metaData[j].data;
                if (el.name == meta.name) {
                    var value = el instanceof Ext.form.Checkbox ? el.checked : el.getValue();
                    if (value != meta.value) {
                        meta.value = value;
                        isNeedUpdate = true;
                    }
                    if (meta.mandatory && value == null && !el.allowBlank) {
                        this.showErrorMsg(this.labels.fieldsFilledIncorrectly);
                        return false;
                    }
                    break;
                }
            }
        }
        return isNeedUpdate;
    },

    prepareTabButtons: function() {
        // try{
        var tabs = Object.keys(this.tabs);
        if (tabs.length == 0) {
            throw -1;
        }
        var self = this;
        tabs.forEach(function(item, index) {
            tabs[index] = {
                name: item,
                text: item,
                title: mx.translate(item, self.namespace),
                minWidth: this.minButtonWidth,
                allowDepress: false,
                pressed: false,
                onClick: function() {
                    self.propertyTab.getTopToolbar().select(this.name);
                    self.propertyPage.getLayout().setActiveItem('prp_' + this.name.replace(' ', '_'));
                },
            };
        }, this);
        return tabs;
    },

    constructElement: function(item) {
        var type = item.type;
        var element = false;
        var self = this;
        switch (type) {
            case 'TEXTAREA':
                element = new Ext.form.TextArea({
                    fieldLabel: mx.translate(item.label, self.namespace),
                    allowBlank: !item.mandatory,
                    name: item.name,
                    value: item.value,
                    cls: 'property-form-area',
                    afterRender: function() {
                        Ext.form.TextArea.superclass.afterRender.call(this);
                        if (item.value != null && item.value != '') {
                            var formattedString = self.formatObject(item.value);
                            if (formattedString != null && formattedString != '') {
                                this.setValue(formattedString);
                                this.el.dom.style.overflowY = 'scroll';
                                this.el.dom.style.overflowX = 'hidden';
                            } else {
                                this.setValue(item.value);
                            }
                        }
                    },
                });
                break;
            case 'FILE':
                var globalId = this.initialConfig.scope.formConfig.globalId;
                var btn;
                element = new Ext.Panel({
                    name: item.name,
                    getValue: function() {
                        return element.findById('textfield').getValue();
                    },
                    layout: 'column',
                    items: [
                        {
                            columnWidth: 0.8,
                            layout: 'mx-form',
                            border: false,
                            items: [
                                {
                                    xtype: 'textfield',
                                    id: 'textfield',
                                    fieldLabel: mx.translate(item.label, self.namespace),
                                    labelWidth: 253,
                                    value: item.value,
                                    disabled: true,
                                },
                            ],
                        },
                        {
                            columnWidth: 0.2,
                            border: false,
                            items: [(btn = new Ext.ux.ResizableButtonComponent({text: mx.translate('UploadFile')}))],
                        },
                    ],
                });
                btn.on(
                    'click',
                    function() {
                        var wnd = new mx.app.widget.UploadFile({
                            url: mx.PATH + MXAT.API('accounts/uploadFile/' + globalId + '/' + item.name),
                        });
                        wnd.on(
                            'close',
                            function() {
                                element.findById('textfield').setValue(wnd.findById('file').getValue());
                            },
                            this
                        );
                        wnd.show();
                    },
                    this
                );
                break;
            case 'PASSWORD':
                el = {
                    fieldLabel: mx.translate(item.label, self.namespace),
                    allowBlank: !item.mandatory,
                    inputType: 'password',
                    name: item.name,
                    value: item.value,
                };
                if (item.name === 'account_smtp_password') {
                    el.id = 'smtpPassword';
                }
                element = new Ext.form.TextField(el);
                break;
            case 'BOOLEAN':
                var el = {
                    fieldLabel: mx.translate(item.label, self.namespace),
                    name: item.name,
                    checked: eval(item.value),
                };
                if (item.name === ENABLE_RATE_DELIVERY) {
                    el.id = 'enableRateDelivery';
                }
                if (item.name === 'account_smtp_enabled_ssl') {
                    el.id = 'sslEnabled';
                }
                if (item.name === 'account_smtp_enabled_tls') {
                    el.id = 'tlsEnabled';
                }

                element = new Ext.form.Checkbox(el);

                if (item.name === HIDE_RATE_DELIVERY) {
                    element.on('check', function(clickedObject, isChecked) {
                        var enableRateDelivery = Ext.getCmp('enableRateDelivery');
                        var rateWidgetText = Ext.getCmp('rateWidgetText');
                        if (isChecked) {
                            enableRateDelivery.setValue(false);
                            enableRateDelivery.setDisabled(true);
                            rateWidgetText.setDisabled(true);
                        } else {
                            enableRateDelivery.setDisabled(false);
                            rateWidgetText.setDisabled(false);
                        }
                    });
                }

                //when remove checkbox to switch new/old scheduler - remove this code
                // if (item.name === 'enableMicroserviceScheduler') {
                //     element.on(
                //         'check',
                //         function(clickedObject, isChecked) {
                //             var radioHCDLS = Ext.getCmp('radio_HCDLS');
                //             var radioSADLSATL = Ext.getCmp('radio_SADLSATL');
                //             var radioINSERTIONS = Ext.getCmp('radio_INSERTIONS');
                //             var radioCentroid = Ext.getCmp('radio_CentroidLocalSearch');
                //             var radioTIME = Ext.getCmp('radio_TIME');
                //             var radioStrict = Ext.getCmp('radio_Strict');
                //             var radioSoft = Ext.getCmp('radio_Soft');
                //             if (isChecked) {
                //                 self.newSchedulerOn = true;
                //                 if (radioHCDLS) {
                //                     radioHCDLS.setDisabled(false);
                //                 }
                //                 if (radioSADLSATL) {
                //                     radioSADLSATL.setDisabled(false);
                //                 }
                //                 if (radioINSERTIONS) {
                //                     radioINSERTIONS.setDisabled(false);
                //                 }
                //                 if (radioStrict) {
                //                     radioStrict.setDisabled(false);
                //                 }
                //             } else {
                //                 self.newSchedulerOn = false;
                //                 if (
                //                     (radioHCDLS && radioHCDLS.getValue()) ||
                //                     (radioSADLSATL && radioSADLSATL.getValue())
                //                 ) {
                //                     radioHCDLS.setValue(false);
                //                     radioSADLSATL.setValue(false);
                //                     if (radioCentroid) {
                //                         radioCentroid.setValue(true);
                //                     }
                //                 }
                //                 if (radioINSERTIONS && radioINSERTIONS.getValue()) {
                //                     radioINSERTIONS.setValue(false);
                //                     if (radioTIME) {
                //                         radioTIME.setValue(true);
                //                     }
                //                 }
                //                 if (radioStrict && radioStrict.getValue()) {
                //                     radioStrict.setValue(false);
                //                     if (radioSoft) {
                //                         radioSoft.setValue(true);
                //                     }
                //                 }
                //                 if (radioHCDLS) {
                //                     radioHCDLS.setDisabled(true);
                //                 }
                //                 if (radioSADLSATL) {
                //                     radioSADLSATL.setDisabled(true);
                //                 }
                //                 if (radioINSERTIONS) {
                //                     radioINSERTIONS.setDisabled(true);
                //                 }
                //                 if (radioStrict) {
                //                     radioStrict.setDisabled(true);
                //                 }
                //             }
                //         },
                //         element
                //     );
                // }
                //

                break;
            case 'BOOLEAN_RELATED':
                element = new Ext.form.Checkbox({
                    fieldLabel: mx.translate(item.label, self.namespace),
                    name: item.name,
                    checked: eval(item.value),
                    inner_scope: this,
                    item: item,
                    afterRender: function() {
                        Ext.form.Checkbox.superclass.afterRender.call(this);
                        this.inner_scope.switchEnable.call(this);
                    },
                    scope: this,
                });
                element.on('check', this.switchEnable, element);
                this.related[item.relation] = !element.checked;
                break;
            case 'LIST':
                var variants = [];
                if ('variants' in item) {
                    item.variants.forEach(function(v) {
                        if ('data' in v) {
                            v = v.data;
                        }
                        variants.push([v.value, mx.translate(v.label, self.namespace)]);
                    });
                }

                element = new Ext.form.ComboBox({
                    store: new Ext.data.SimpleStore({
                        fields: ['field_id', 'field_name'],
                        id: 0,
                        data: variants,
                    }),
                    displayField: 'field_name',
                    valueField: 'field_id',
                    mode: 'local',
                    fieldLabel: mx.translate(item.label, self.namespace),
                    name: item.name,
                    value: item.value,
                    forceSelection: true,
                    triggerAction: 'all',
                });
                break;
            case 'RADIO':
                var variants = [];
                var itemName = item.name;
                item.variants.forEach(function(v) {
                    if ('data' in v) {
                        v = v.data;
                    }
                    var variant = {};
                    variant.name = v.name;
                    variant.inputValue = v.value;
                    variant.boxLabel = mx.translate(v.label, self.namespace);

                    //when remove checkbox to switch new/old scheduler - remove this code
                    // if (
                    //     v.value === 'HCDLS' ||
                    //     v.value === 'SADLSATL' ||
                    //     v.value === 'INSERTIONS' ||
                    //     v.value === 'Strict'
                    // ) {
                    //     variant.id = 'radio_' + v.value;
                    //     if (!self.newSchedulerOn) {
                    //         variant.disabled = 'true';
                    //     }
                    // }
                    // if (v.value === 'CentroidLocalSearch' || v.value === 'TIME' || v.value === 'Soft') {
                    //     variant.id = 'radio_' + v.value;
                    // }
                    //

                    if (item.value === v.value) {
                        variant.checked = true;
                    }
                    variants.push(variant);
                });
                element = new Ext.form.RadioGroup({
                    fieldLabel: mx.translate(item.label, self.namespace),
                    columns: 1,
                    vertical: true,
                    items: variants,
                    name: itemName,
                    getValue: function() {
                        return this.items.get(0).getGroupValue();
                    },
                });
                break;
            case 'INTEGER':
            case 'FLOAT':
                el = {
                    fieldLabel: mx.translate(item.label, self.namespace),
                    name: item.name,
                    value: item.value,
                    allowBlank: !item.mandatory,
                    strategy: {
                        xtype: 'number',
                        allowDecimals: type == 'FLOAT',
                        minValue: item.minValue,
                        maxValue: item.maxValue,
                    },
                };
                if (item.name === 'account_smtp_port') {
                    el.id = 'smtpPort';
                }
                element = new Ext.ux.form.Spinner(el);
                break;
            case 'PERIOD_FIELD_WITH_MS': // Использует в качестве минимальной единицы измерения миллисекунду, поэтому добавлен отдельным компонентом.
                var comboData = [];
                if ('variants' in item) {
                    item.variants.forEach(function(v) {
                        if ('data' in v) {
                            v = v.data;
                        }
                        switch (v.value) {
                            case 'ms':
                                comboData.push(['ms', mx.translate(v.label, self.namespace)]);
                                break;
                            case 's':
                                comboData.push(['s', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'm':
                                comboData.push(['m', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'h':
                                comboData.push(['h', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'd':
                                comboData.push(['d', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'w':
                                comboData.push(['w', mx.translate(v.label, self.namespace)]);
                                break;
                        }
                    });
                    element = new mx.comp.PeriodFieldMS({
                        name: item.name,
                        fieldLabel: mx.translate(item.label, self.namespace),
                        allowBlank: !item.mandatory,
                        spinnerDefaultValue: 0,
                        comboDefaultValue: 'm',
                        comboData: comboData,
                        comboDisabled: item.variants.length == 1,
                        comboHidden: item.variants.length == 1,
                        comboWidth: 110,
                    });
                    element.setValue(item.value);
                    if (item.variants.length == 1) {
                        element.setText(mx.translate(item.variants[0].data.label, self.namespace));
                    }
                }
                break;
            case 'PERIOD_FIELD':
                var comboData = [];
                if ('variants' in item)
                    item.variants.forEach(function(v) {
                        if ('data' in v) {
                            v = v.data;
                        }
                        switch (v.value) {
                            case 's':
                                comboData.push(['s', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'm':
                                comboData.push(['m', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'h':
                                comboData.push(['h', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'd':
                                comboData.push(['d', mx.translate(v.label, self.namespace)]);
                                break;
                            case 'w':
                                comboData.push(['w', mx.translate(v.label, self.namespace)]);
                                break;
                        }
                    });
                element = new mx.comp.PeriodField({
                    name: item.name,
                    fieldLabel: mx.translate(item.label, self.namespace),
                    allowBlank: !item.mandatory,
                    spinnerDefaultValue: 0,
                    comboDefaultValue: 'm',
                    comboData: comboData,
                    comboDisabled: item.variants.length == 1,
                });
                element.setValue(item.value);
                break;
            case 'TIME_INTERVAL':
                element = new mx.comp.DayField({
                    fieldLabel: mx.translate(item.label, self.namespace) + ':',
                    labelSeparator: '',
                    hideLabel: false,
                    name: item.name,
                    showCheckbox: false,
                    isFieldContainer: true,
                    labelWidth: '0',
                    getValue: function() {
                        return this.spinnerFrom.getValue() + '-' + this.spinnerTo.getValue();
                    },
                    getName: function() {
                        return this.name;
                    },
                    setValue: function(val) {
                        this.spinnerFrom.setValue(val.start_time);
                        this.spinnerFrom.setDisabled(false);
                        this.spinnerFrom.initValue();

                        this.spinnerTo.setValue(val.end_time);
                        this.spinnerTo.setDisabled(false);
                        this.spinnerTo.initValue();
                    },
                });
                var times = item.value.split('-');
                element.setValue({
                    available: true,
                    start_time: times[0],
                    end_time: times[1],
                });
                break;
            case 'OPERATION':
                // <----------------------- OPERATION START ----------------------->
                var argumentFields = {};
                var argumentFieldList = [];

                if ('variants' in item) {
                    // CREATE FIELD FOR EACH ARGUMENT
                    var operationArguments = item.variants;
                    operationArguments.forEach(function(v) {
                        if ('data' in v) {
                            v = v.data;
                        }
                        var varType = v.type;
                        var argument;
                        if (varType == 'TEXT') {
                            argument = new Ext.form.TextField({
                                fieldLabel: mx.translate(v.label, self.namespace),
                                name: v.name,
                            });
                        } else if (varType == 'INTEGER' || varType == 'FLOAT') {
                            argument = new Ext.ux.form.Spinner({
                                fieldLabel: mx.translate(v.label, self.namespace),
                                name: v.name,
                                value: v.value,
                                allowBlank: !v.mandatory,
                                strategy: {
                                    xtype: 'number',
                                    allowDecimals: varType == 'FLOAT',
                                },
                            });
                        } else if (varType == 'BOOLEAN') {
                            argument = new Ext.form.Checkbox({
                                fieldLabel: mx.translate(v.label, self.namespace),
                                name: v.name,
                                checked: false,
                            });
                        }
                        argumentFields[v.name] = argument;
                        argumentFieldList.push(argument);
                    });
                }
                var applicationTemplateId = this.applicationTemplateId.getValue();

                var buildParams = function() {
                    var argumentList = [];
                    argumentFieldList.forEach(function(control) {
                        argumentList.push({
                            name: control.getName(),
                            value: control.getValue(),
                        });
                    });
                    return {
                        applicationTemplateId: applicationTemplateId,
                        name: item.name,
                        arguments: argumentList,
                    };
                };
                break;
            case 'HUE_COLOR':
                element = new mx.app.widget.HuePicker({
                    fieldLabel: mx.translate(item.label, self.namespace),
                    value: item.value,
                    name: item.name,
                });
                break;
            case 'LIMITATION':
                element = new mx.app.widget.Limitation({
                    fieldLabel: mx.translate(item.label, self.namespace),
                    name: item.name,
                });
                element.setValue(item.value);
                break;
            case 'BUTTON':
                /**
                 * Костыль. Сделано для кнопки теста настроек smtp. С сервера не присылается, добавляется на клиенте уже.
                 */
                if (item.name === 'account_smtp_test_button') {
                    var button = new Ext.ux.ResizableButtonComponent({text: mx.translate(item.value)});
                    button.on(
                        'click',
                        function() {
                            Ext.MessageBox.show({
                                title: 'Please wait',
                                msg: 'Testing SMTP settings...',
                                width: 300,
                                closable: false,
                            });
                            Ext.Ajax.request({
                                url: '/mxm/mxm-api/mailSettings/sendTestEmailMessage',
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                jsonData: {
                                    smtpFromAddress: Ext.getCmp('smtpFromAddress').getValue(),
                                    smtpFromName: Ext.getCmp('smtpFromName').getValue(),
                                    smtpPassword: Ext.getCmp('smtpPassword').getValue(),
                                    smtpPort: Ext.getCmp('smtpPort').getValue(),
                                    smtpServer: Ext.getCmp('smtpServer').getValue(),
                                    smtpUser: Ext.getCmp('smtpUser').getValue(),
                                    sslEnabled: Ext.getCmp('sslEnabled').getValue(),
                                    tlsEnabled: Ext.getCmp('tlsEnabled').getValue(),
                                },
                                success: function() {
                                    Ext.MessageBox.hide();
                                    Ext.MessageBox.show({
                                        title: 'Test SMTP settings',
                                        msg: 'SMTP settings are correct!',
                                        icon: Ext.Msg.INFO,
                                        buttons: Ext.Msg.OK,
                                    });
                                },
                                failure: function() {
                                    Ext.MessageBox.hide();
                                    Ext.MessageBox.show({
                                        title: 'Test SMTP settings',
                                        msg: 'SMTP settings are incorrect!',
                                        icon: Ext.Msg.ERROR,
                                        buttons: Ext.Msg.OK,
                                    });
                                },
                            });
                        },
                        this
                    );

                    element = new Ext.Panel({
                        items: [button],
                    });
                }
                break;
            default:
                el = {
                    fieldLabel: mx.translate(item.label, self.namespace),
                    allowBlank: !item.mandatory,
                    name: item.name,
                    value: item.value,
                };

                if (item.name === RATE_WIDGET_TEXT) {
                    el.id = 'rateWidgetText';
                }
                if (item.name === 'account_smtp_email_host') {
                    el.id = 'smtpServer';
                }
                if (item.name === 'account_smtp_user') {
                    el.id = 'smtpUser';
                }
                if (item.name === 'account_smtp_from_email') {
                    el.id = 'smtpFromAddress';
                }
                if (item.name === 'account_smtp_from_name') {
                    el.id = 'smtpFromName';
                }
                element = new Ext.form.TextField(el);
                break;
        }
        return element;
    },

    switchEnable: function(form) {
        var el = this.inner_scope.getForm().findField(this.item.relation);
        if (!el) return;
        el.setDisabled(!this.checked);
    },

    createDescriptionField: function(item) {
        var text = mx.translate(item.notice, this.namespace);
        return new Ext.form.Label({
            html: '<span style="color:' + (item.isImportantNotice ? 'red' : 'darkgrey') + '">' + text + '</span>',
            autoWidth: true,
        });
    },

    isGroup: function(element) {
        return element instanceof Ext.form.CheckboxGroup;
    },

    /**
     * Костыльный метод добавления кнопки тестирования smtp настроек
     * @param metaData массив настроек, пришедший с сервера
     */
    addTestSmtpButton: function(metaData) {
        var testSmtpButton = {
            data: {
                group: 'Email service',
                hint: 'Test',
                label: 'accountSmtpTestButton',
                mandatory: true,
                name: 'account_smtp_test_button',
                order: 8,
                readOnly: false,
                tab: 'emailAccountSettingsTab',
                type: 'BUTTON',
                value: 'Test',
            },
        };
        metaData.push(testSmtpButton);
    },

    appendItems: function(recordList) {
        this.related = {};
        this.tabs = {};

        if ('metaData' in recordList) {
            this.metaData = recordList.metaData;
        } else if (recordList instanceof Array) {
            this.metaData = recordList;
            //добавление кнопки только в настройки аккаунта
            this.addTestSmtpButton(this.metaData);
        } else return;

        for (var i = 0; i < this.metaData.length; i++) {
            if (
                'data' in this.metaData[i] &&
                this.metaData[i].data.name === 'enableMicroserviceScheduler' &&
                eval(this.metaData[i].data.value)
            ) {
                this.newSchedulerOn = true;
            }
            if (
                'data' in this.metaData[i] &&
                this.metaData[i].data.name === HIDE_RATE_DELIVERY &&
                eval(this.metaData[i].data.value)
            ) {
                this.hideRateDelivery = true;
            }
        }
        var widgetGroupExtended = {radio: null, pathText: null};
        this.metaData.forEach(function(item) {
            if ('data' in item) {
                item = item.data;
            }
            var tab = this.tabAlign != 'none' ? item.tab : 'none';
            if (!(tab in this.tabs)) {
                this.tabs[tab] = [];
            }
            var element, fieldGroup, description;
            if ((element = this.constructElement(item))) {
                element.setDisabled(item.readOnly || this.related[element.name]);
                if (item.name === ENABLE_RATE_DELIVERY || item.name === RATE_WIDGET_TEXT) {
                    element.setDisabled(this.hideRateDelivery);
                }
                element.setWidth(550);
                fieldGroup = element;
                if (item.notice && item.notice != '') {
                    description = this.createDescriptionField(item);
                    if (this.isGroup(element)) {
                        element.items.push(description);
                    } else {
                        fieldGroup = new mx.comp.FieldGroup({
                            fieldLabel: mx.translate(item.label, this.namespace),
                            columns: [1],
                            autoWidth: true,
                            items: [element, description],
                        });
                    }
                }
                fieldGroup.order = item.order;
                fieldGroup.metaData = true;
                this.getForm().add(fieldGroup);
                item.element = fieldGroup;
                this.tabs[tab].push(item);
                if (tab == 'System parameters') {
                    if (element.name == 'usageWidgetType') {
                        widgetGroupExtended.radio = element;
                    }
                    if (element.name == 'maxoptra.notification.locationWidgetBaseAddress') {
                        widgetGroupExtended.pathText = element;
                    }
                }
            }
        }, this);

        if (widgetGroupExtended.radio) {
            widgetGroupExtended.radio.items.forEach(function(value) {
                if (value.inputValue == 'widgetInternal') {
                    if (value.checked) {
                        widgetGroupExtended.pathText.enable();
                    } else {
                        widgetGroupExtended.pathText.disable();
                    }
                }
            });
            widgetGroupExtended.radio.on('change', function() {
                if (widgetGroupExtended.radio.getValue() == 'widgetInternal') {
                    widgetGroupExtended.pathText.enable();
                } else {
                    widgetGroupExtended.pathText.disable();
                }
            });
        }

        for (var nid in this.tabs) {
            var fields = this.tabs[nid];
            var item = new Ext.Panel({
                id: 'prp_' + nid.replace(' ', '_'),
                border: false,
                region: 'center',
                layout: 'mx-form',
                autoScroll: false,
                autoHeight: true,
            });

            var grouped = {};
            fields.forEach(function(item) {
                if ('element' in item) {
                    if (!grouped[item.group || '']) {
                        grouped[item.group || ''] = [];
                    }
                    grouped[item.group || ''].push(item.element);
                    delete item.element;
                }
            }, this);
            for (var p in grouped) {
                var itemList = grouped[p]; // list of elements of specified group
                itemList.sort(function(a, b) {
                    if (parseInt(a.order) > parseInt(b.order)) return 1;
                    if (parseInt(a.order) < parseInt(b.order)) return -1;
                    return 0;
                });

                item.add({
                    columnWidth: 0.8,
                    border: false,
                    layout: 'fit',
                    anchor: '-15',
                    autoScroll: false,
                    items: new Ext.form.FieldSet({
                        title: mx.translate(p, this.namespace),
                        autoHeight: true,
                        hideBorders: true,
                        collapsible: false,
                        labelWidth: 250,
                        anchor: '-10',
                        width: 580,
                        defaults: {
                            anchor: '100%',
                        },
                        items: itemList,
                    }),
                });
            }
            this.propertyPage.add(item);
        }

        switch (this.tabAlign) {
            case 'vertical':
                if (Object.keys(this.tabs).length > 1) {
                    this.propertyTab.getTopToolbar().addNavigables(this.prepareTabButtons());
                } else {
                    this.propertyTab.hide();
                    this.propertyPage.removeClass(self.pageCLs);
                    this.propertyPage.addClass(self.pageCLs + '-full');
                }
                this.add(this.propertyTab, this.propertyPage);
                break;
            case 'horizontal':
                var tabs = this.prepareTabButtons();
                tabs.forEach(function(item) {
                    this.propertyTab.add(item);
                }, this);
                this.add(this.propertyTab, this.propertyPage);
            case 'none':
                this.add(this.propertyPage);
                break;
        }

        this.doLayout();
    },

    initComponent: function() {
        mx.app.widget.PropertyForm.superclass.initComponent.apply(this, arguments);

        var self = this;
        var tabPageConfig = {
            name: 'property_page_container',
            layout: 'card',
            cls: self.pageCLs,
            region: 'center',
            border: false,
            autoScroll: false,
            autoWidth: true,
            activeItem: 0,
        };
        switch (this.tabAlign) {
            case 'vertical':
                this.propertyTab = new Ext.Panel({
                    cls: self.tabCLs,
                    name: 'property_tab_container',
                    region: 'west',
                    layout: 'fit',
                    border: false,
                    bodyBorder: false,
                    autoScroll: false,
                    tbar: new mx.comp.Toolbar({
                        cls: 'ac-property-toolbar',
                        minButtonWidth: '100%',
                        vertical: true,
                        border: false,
                    }),
                    afterRender: function() {
                        this.getTopToolbar().select(Object.keys(self.tabs)[0]);
                    },
                });
                break;
            case 'horizontal':
                this.propertyTab = new Ext.TabPanel({
                    cls: self.tabCLs,
                    name: 'property_tab_container',
                    border: false,
                    bodyBorder: false,
                    autoScroll: false,
                    activeTab: 0,
                    listeners: {
                        tabchange: function(that, sender) {
                            if (this.propertyPage.rendered) {
                                self.propertyPage.getLayout().setActiveItem('prp_' + sender.name.replace(' ', '_'));
                            }
                        },
                        scope: this,
                    },
                });
            case 'none':
                tabPageConfig.cls += '-full';
                break;
        }

        this.propertyPage = new Ext.Panel(tabPageConfig);

        if (this.metaData) {
            this.appendItems(this.metaData);
        }
    },

    formatObject: function(string) {
        try {
            var o = JSON.parse(string);
            if (o.constructor === Array || o.constructor === Object) {
                return JSON.stringify(o, null, '\t');
            }
        } catch (e) {}
        return null;
    },
});
